import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const IconText = ({children, searchString, value, text, title}) => {
	return (
		<Container>
			<IconContainer>{children}</IconContainer>
			<TextContainer>
				{title ? <Title>{title}</Title> : null}
				<Text>{text}</Text>
			</TextContainer>
		</Container>
	);
};

export const TextContainer = Styled.div`
	cursor: default;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-between;
`;

export const Title = Styled.div`
	opacity: 0.7;
	font-size: 9px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Container = Styled.div`
	background-color: transparent;
	display: flex;
	flex-direction: row;
	padding: 5px 0;
	width: 100%;
	align-items: center;
`;

export const IconContainer = Styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 5px;
`;

export const Text = Styled.p`
	padding: 0;
	margin: 0;
	flex-grow: 1;
	font-size: 13px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${props => props.theme.colors.textLightGray};
`;

IconText.propTypes = {
	children: PropTypes.any,
	text: PropTypes.string,
	searchString: PropTypes.string,
	value: PropTypes.any,
	title: PropTypes.any,
};
